import { CATEGORY_FILTER_KEY, MORE_FILTER_TITLE } from 'shared/layouts/Listing/constants';

export const transformFilters = (filters: any) => {
  let categoryFilter: any = {};
  return filters.reduce((finalFilters, filter) => {
    if (filter.key === CATEGORY_FILTER_KEY) categoryFilter = filter;
    if (filter.title === MORE_FILTER_TITLE) {
      categoryFilter.message = filter.message;
      return finalFilters;
    }
    return [...finalFilters, filter];
  }, []);
};
